import { UpdateUserBulkResponse, User } from '@/models/gen/graphql';
import { createNotification, handleError } from '@/utils/custom';

import { GraphApiResponse } from '@/api/core';
import Toast from '@/models/Toast';
import { UpdateUserBulkDocument } from '@/api/queries';
import { generateUpdateBulkPayload } from '@/utils';
import graphApi from '@/api';

type UpdateUserBulkGraphApiResponse = GraphApiResponse<typeof UpdateUserBulkDocument>;

const title = 'Update User Bulk';

const updateUserBulkResponseSelector = (res: UpdateUserBulkGraphApiResponse): UpdateUserBulkResponse['response'] =>
  res?.updateUserBulk?.response;

const [runUpdateUserBulk] = graphApi(UpdateUserBulkDocument, {
  onError: (res: UpdateUserBulkGraphApiResponse): void => handleError(res, { notification: { title } }),
});

const updateUserBulk = async (...users: Partial<User>[]): Promise<UpdateUserBulkResponse['response']> => {
  const updates = generateUpdateBulkPayload(users);

  const res = await runUpdateUserBulk({ input: { updates } });
  const data = updateUserBulkResponseSelector(res);

  if (data) createNotification('Success', Toast.Type.SUCCESS, title);

  return data;
};

export default updateUserBulk;
